import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterDatalakeANBIMAPrecosTPFTable = (props) => {
    const datalakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.loading(false)
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            "ISIN": null,
            "SELIC": null,
            "DataReferencia": null,
            "TaxaCompra": null,
            "TaxaVenda": null,
            "TaxaIndicativa": null,
            "PUIndicativo": null,
            "DesvioPadrao": null,
            "TaxaMinimaD0": null,
            "TaxaMaximaD0": null,
            "TaxaMinimaD1": null,
            "TaxaMaximaD1": null
        }

        props.loading(true)
        return datalakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, ISIN, SELIC, DataReferencia, TaxaCompra, TaxaVenda, TaxaIndicativa, 
            PUIndicativo, DesvioPadrao, TaxaMinimaD0, TaxaMaximaD0, TaxaMinimaD1, TaxaMaximaD1
        } = newRow

        const body = {
            "ISIN": ISIN,
            "SELIC": SELIC,
            "DataReferencia": DataReferencia,
            "TaxaCompra": TaxaCompra,
            "TaxaVenda": TaxaVenda,
            "TaxaIndicativa": TaxaIndicativa,
            "PUIndicativo": PUIndicativo,
            "DesvioPadrao": DesvioPadrao,
            "TaxaMinimaD0": TaxaMinimaD0,
            "TaxaMaximaD0": TaxaMaximaD0,
            "TaxaMinimaD1": TaxaMinimaD1,
            "TaxaMaximaD1": TaxaMaximaD1
        }

        props.loading(true)
        return datalakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return datalakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }


    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        datalakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'ISIN',
            headerName: 'ISIN',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true,
        },
        {
            field: 'SELIC',
            headerName: 'SELIC',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true,
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true,
            typeComponent: 'date',
        },
        {
            field: 'TaxaCompra',
            headerName: 'TaxaCompra',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true,
            typeComponent: 'number',
        },
        {
            field: 'TaxaVenda',
            headerName: 'TaxaVenda',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true,
            typeComponent: 'number',
        },
        {
            field: 'TaxaIndicativa',
            headerName: 'TaxaIndicativa',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true,
            typeComponent: 'number',
        },
        {
            field: 'PUIndicativo',
            headerName: 'PUIndicativo',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true,
            typeComponent: 'number',
        },
        {
            field: 'DesvioPadrao',
            headerName: 'DesvioPadrao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true,
            typeComponent: 'number',
        },
        {
            field: 'TaxaMinimaD0',
            headerName: 'TaxaMinimaD0',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true,
            typeComponent: 'number',
        },
        {
            field: 'TaxaMaximaD0',
            headerName: 'TaxaMaximaD0',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true,
            typeComponent: 'number',
        },
        {
            field: 'TaxaMinimaD1',
            headerName: 'TaxaMinimaD1',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true,
            typeComponent: 'number',
        },
        {
            field: 'TaxaMaximaD1',
            headerName: 'TaxaMaximaD1',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true,
            typeComponent: 'number',
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                pagination={pagination}
                onChangePage={changePage}
                filterFunction={onFilter}
                customFilter={true} />
        </div>
    )
}

ParameterDatalakeANBIMAPrecosTPFTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterDatalakeANBIMAPrecosTPFTable